import { UseAccordionType } from './accordionType'

const useAccordion = (props: UseAccordionType) => {
    const {} = props

    return {}
}

export default useAccordion
